<template>

    <router-link v-if="router && router.name" tag="li" :to="router">
        <a :class="active" href="#">
            <i :class="icon"/> <span>{{ name }}</span>
        </a>
        <ul class="nav-second-level" v-if="data.sub">
        <slidebar-sub-item v-if="active == 'active'" v-for="(item,index) in data.sub" :key="index" :data="item" :type="item.type"
                     :name="item.name" :router="item.router"/>
        </ul>
    </router-link>
</template>

<script>

    import SlidebarSubItem from "./SlidebarSubItem";

    export default {
        name: "SlidebarItem",
        components: {SlidebarSubItem},
        props: {
            data:{
                type: Object,
                default() {
                    return {}
                }
            },
            type: {
                type: String,
                default: 'item'
            },
            isHeader: {
                type: Boolean,
                default: false
            },
            icon: {
                type: String,
                default: ''
            },
            name: {
                type: String
            },
            active: {
                type: String,
                default: ''
            },
            badge: {
                type: Object,
                default() {
                    return {}
                }
            },
            items: {
                type: Array,
                default() {
                    return []
                }
            },
            router: {
                type: Object,
                default() {
                    return {
                        name: ''
                    }
                }
            },
            link: {
                type: String,
                default: ''
            }
        },


    }
</script>

<style scoped lang="scss">

</style>